import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from "@libs/rubick";
import { FILTER_VALUES } from "@/constants/filters";
import { useAvailableProducts } from "@/hooks/products";
import { isAuthHttpError } from "@/utils/httpError";
import { filterMeteredProducts } from "@/utils/products";
export const ProductsDropdown = ({ value, onChange, showAllOption = true, extraProducts = [], options: providedOptions, expiredOptions: providedExpiredOptions, isLoading: providedIsLoading, error: providedError, optionType = "product" })=>{
    const usesProvidedOptions = providedOptions !== undefined;
    const { data: productsData, isLoading: productsLoading, error: productsError } = useAvailableProducts(!usesProvidedOptions);
    const products = filterMeteredProducts(productsData?.products);
    const options = providedOptions ?? products.map((product)=>({
            label: product.productName,
            value: product.productCode
        }));
    const expiredOptions = providedExpiredOptions ?? extraProducts.map((product)=>({
            label: `${product.productName} (Expired)`,
            value: product.productCode
        }));
    const isLoading = usesProvidedOptions ? providedIsLoading ?? false : productsLoading;
    const error = usesProvidedOptions ? providedError : productsError;
    const optionCount = options.length + expiredOptions.length;
    const optionNoun = optionType === "contract" ? "contract" : "product";
    if (error) {
        const isAuthError = isAuthHttpError(error);
        return /*#__PURE__*/ _jsxs("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ _jsx("label", {
                    htmlFor: "product",
                    className: "block text-sm font-medium text-gray-700 mb-2",
                    children: "Product"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "relative",
                    children: /*#__PURE__*/ _jsx(Select, {
                        id: "product",
                        value: "",
                        disabled: true,
                        children: /*#__PURE__*/ _jsx("option", {
                            value: "",
                            children: "Unable to load products"
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mt-1.5 text-xs text-red-500 pl-1",
                    children: isAuthError ? "Authentication required to load products" : `Unable to load ${optionNoun}s`
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx("label", {
                htmlFor: "product",
                className: "block text-sm font-medium text-gray-700 mb-2",
                children: "Product"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "relative",
                children: /*#__PURE__*/ _jsxs(Select, {
                    id: "product",
                    value: optionCount === 0 ? "" : value,
                    onChange: (event)=>onChange(event.target.value),
                    disabled: isLoading || optionCount === 0,
                    children: [
                        showAllOption && (isLoading || optionCount > 0) && /*#__PURE__*/ _jsx("option", {
                            value: FILTER_VALUES.ALL,
                            className: "py-2",
                            children: isLoading ? "Loading Products..." : "All Products"
                        }),
                        !showAllOption && isLoading && /*#__PURE__*/ _jsx("option", {
                            value: "",
                            className: "py-2",
                            children: "Loading Products..."
                        }),
                        !isLoading && optionCount === 0 && /*#__PURE__*/ _jsx("option", {
                            value: "",
                            children: "No available products"
                        }),
                        options.map((option)=>/*#__PURE__*/ _jsx("option", {
                                value: option.value,
                                className: "py-2",
                                children: option.label
                            }, option.value)),
                        expiredOptions.length > 0 && /*#__PURE__*/ _jsx("optgroup", {
                            label: "Expired Contracts",
                            children: expiredOptions.map((option)=>/*#__PURE__*/ _jsx("option", {
                                    value: option.value,
                                    className: "py-2",
                                    children: option.label
                                }, option.value))
                        })
                    ]
                })
            }),
            !isLoading && optionCount > 0 && /*#__PURE__*/ _jsxs("p", {
                className: "mt-1.5 text-xs text-gray-500 pl-1",
                children: [
                    options.length,
                    " active ",
                    optionNoun,
                    options.length === 1 ? "" : "s",
                    " available",
                    expiredOptions.length > 0 && /*#__PURE__*/ _jsxs("span", {
                        className: "text-yellow-600 ml-1",
                        children: [
                            "(",
                            expiredOptions.length,
                            " expired)"
                        ]
                    })
                ]
            }),
            !isLoading && optionCount === 0 && /*#__PURE__*/ _jsx("p", {
                className: "mt-1.5 pl-1 text-xs text-yellow-600",
                children: "No available products."
            })
        ]
    });
};
